import { NUMBER_OF_PLAYERS } from 'constants/params';
import { isNull } from 'components/app/_helpers/_app.helper';
import { SbPlaybackParams } from 'components/app/storyboard/_mediator/sb.slice';
import { PlaybackElement, State } from './sb-player.slice';

type Active = Index | null;
type Damping = Index | null;
type Res = [Active, Damping];

export const getPlaybackPlayers = (data: State): Res => {
  const { activePlayerIndex, dampingPlayerIndex, isEmptyCell, playbackClips } = data;
  let players: Res = [null, null];
  if (isEmptyCell) {
    if (!isNull(dampingPlayerIndex)) players = [null, dampingPlayerIndex];
  } else if (activePlayerIndex === dampingPlayerIndex) {
    players = [activePlayerIndex, null];
  } else if (isNull(dampingPlayerIndex)) {
    players = [activePlayerIndex, null];
  } else players = [activePlayerIndex, dampingPlayerIndex];
  return players.map((index) => {
    if (index === null) return null;
    return isImage(playbackClips[index]) ? null : index;
  }) as Res;
};

export const getPlayerTime = (
  cursorTime: EditorTime,
  playbackParams: SbPlaybackParams,
  markers: MarkerId[],
  cell: Index
) => {
  const { rate, idleStart, startTime } = playbackParams;
  const cellStartTime = cell === 0 ? 0 : markers[cell - 1];
  const cellCursorTime = (cursorTime - cellStartTime) * rate;
  if (!idleStart) return startTime + cellCursorTime;
  if (cellCursorTime < idleStart) return startTime;
  return cellCursorTime - idleStart;
};

export const isImage = (element: PlaybackElement) => {
  return !!(element && !Array.isArray(element) && /0-0$/.test(element));
};

export const isLinkedGroup = (element: PlaybackElement) => {
  return Array.isArray(element);
};

export const playerIsPlaying = (player: HTMLVideoElement) => {
  return player.currentTime > 0 && !player.paused && !player.ended;
};

export const getPrevIndex = (activePlayerIndex: Index) => {
  return activePlayerIndex === 0 ? NUMBER_OF_PLAYERS - 1 : activePlayerIndex - 1;
};

export const isLoaderActive = (readyToPlay: boolean[], playbackClips: PlaybackElement[], activePlayerIndex: Index) => {
  return readyToPlay.some(
    (isReady, i) => i !== getPrevIndex(activePlayerIndex) && playbackClips[i] && !isImage(playbackClips[i]) && !isReady
  );
};
